module.exports = __webpack_public_path__ + "img/cooperate_yh_06@2x.27d008aa.png";